<template>
  <div>
    <el-dialog
      top="10vh"
      width="705px"
      center
      :title="`「${data.username}」上下线记录详情`"
      :visible.sync="dialogVisible"
      @close="HandleCancel"
    >
      <el-descriptions :column="1" border :content-style="{ width: '50%' }">
        <el-descriptions-item label="当前连线状态">
          <div :style="`color: ${connectionHealthStatusColorCode}`">
            <i class="el-icon-s-opportunity" />
            {{ connectionHealthStatus }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="24小时内在线时长"
          >{{ HandleTimeStampToDatetimeFormat(connectionHealthOnlineSeconds) }}
        </el-descriptions-item>
        <el-descriptions-item label="24小时内断线次数">
          {{ connectionHealthOfflineCount }} 次</el-descriptions-item
        >
      </el-descriptions>

      <el-table
        v-loading="tableLoading"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        element-loading-spinner="el-icon-loading"
        :data="dataList"
      >
        <el-table-column label="上下线状态">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.event === 0"
              size="medium"
              type="success"
              effect="dark"
            >
              {{ scope.row.createTime }} 上线
            </el-tag>
            <el-tag
              v-if="scope.row.event === 1"
              size="medium"
              type="danger"
              effect="dark"
            >
              {{ scope.row.createTime }} 下线
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="在线时长">
          <template slot-scope="scope">
            {{
              HandleTimeStampToDatetimeFormat(scope.row.onlineSeconds) || "-"
            }}
          </template>
        </el-table-column>
        <el-table-column label="装置资讯">
          <template slot-scope="scope">
            {{ scope.row.deviceInfo }}
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="pageQuery.pageNum"
        :limit.sync="pageQuery.pageSize"
        @pagination="HandleGetList"
      />
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import varCommon from "@/utils/varCommon";
import Pagination from "@/views/components/Pagination";
import { loginRecordList } from "@/api/user";

export default {
  mixins: [mainCommon],
  props: ["data"],
  data() {
    return {
      dialogVisible: false,
      dataList: [],
      total: 0,
      tableLoading: false,
      connectionHealthStatusColorCode: null,
      connectionHealthStatus: null,
      connectionHealthOfflineCount: null,
      connectionHealthOnlineSeconds: null,
      pageQuery: {
        pageSize: varCommon.pagination.pageSize,
        pageNum: 1,
        userId: null,
      },
    };
  },
  watch: {
    data(row) {
      if (row) {
        this.pageQuery.id = row.id;
        this.HandleGetList();
        this.dialogVisible = true;
      }
    },
  },
  components: {
    Pagination,
  },
  methods: {
    HandleCancel() {
      this.pageQuery.id = null;
      this.dialogVisible = false;
    },
    HandleGetList() {
      this.tableLoading = true;
      loginRecordList(this.ObjectClean(this.pageQuery))
        .then((res) => {
          this.total = res.data.total;
          this.dataList = res.data.list;
          this.connectionHealthStatusColorCode =
            res.data.connectionHealthStatusColorCode;
          this.connectionHealthStatus = res.data.connectionHealthStatus;
          this.connectionHealthOfflineCount =
            res.data.connectionHealthOfflineCount;
          this.connectionHealthOnlineSeconds =
            res.data.connectionHealthOnlineSeconds;
          this.tableLoading = false;
        })
        .catch(() => {});
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/components/dialog/UserLoginRecordDetail.vue